// People.jsx
import React, { useState } from 'react'
import styles from './styles.module.css'

export default function People ({ record }) {
  const people = record?.people || []
  const [isExpanded, setIsExpanded] = useState(false)

  // Sort by dateSeen descending
  const sortedPeople = [...people].sort((a, b) => {
    const dateA = a.dateSeen ? new Date(a.dateSeen) : new Date(0)
    const dateB = b.dateSeen ? new Date(b.dateSeen) : new Date(0)
    return dateB - dateA
  })

  const displayed = isExpanded ? sortedPeople : sortedPeople.slice(0, 5)

  return (
    <section className={styles.peopleExpandedSection}>
      <span className={styles.peopleExpandedHeader}>People</span>
      <div className={styles.peopleExpandedContainer}>
        {sortedPeople.length > 0 ? (
          <>
            {/* Header Row */}
            <div className={styles.peopleExpandedHeaderRow}>
              <span className={styles.peopleExpandedName}>Name</span>
              <span className={styles.peopleExpandedTitle}>Title</span>
              <span className={styles.peopleExpandedDate}>Date Seen</span>
            </div>

            {/* Data Rows */}
            {displayed.map((item, index) => (
              <div key={index} className={styles.peopleExpandedRow}>
                <span className={styles.peopleExpandedName}>{item?.name}</span>
                <span className={styles.peopleExpandedTitle}>{item?.title}</span>
                <span className={styles.peopleExpandedDate}>
                  {item?.dateSeen
                    ? new Intl.DateTimeFormat('en-US', {
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric'
                      }).format(new Date(item.dateSeen))
                    : 'N/A'}
                </span>
              </div>
            ))}
          </>
        ) : (
          <span>N/A</span>
        )}
      </div>

      {sortedPeople.length > 5 && (
        <button
          className={styles.peopleExpandedToggle}
          onClick={() => setIsExpanded(prev => !prev)}
        >
          {isExpanded ? 'Show less' : `Expand All (${sortedPeople.length})`}
        </button>
      )}
    </section>
  )
}